<template>
  <div>
    <SectionResultFilter
      :filter-option="isSelectedRoleExist"
      :csv-filter-options="displayedFilterOptions"
      :already-selected-displayed-columns="filtersData?.displayedColumns"
      @apply="applyFilters"
    />
    <template v-if="isLoading"><Loader class="mt-20 mb-40" :content="true" /></template>
    <div v-else-if="!isLoading && isEmpty(resultsList)">
      <NoRecordFound />
    </div>
    <TableWrapper v-else>
      <THead>
        <TRHead>
          <TH
            v-for="head in tableHeaders.filter((head) => !head.skipForDataTableHead)"
            v-show="showColumnInDataTable(filtersData, head.dataTableName, skipForFilterColumns)"
            :key="head.id"
          >
            {{ head.dataTableName }}
          </TH>
          <TH v-if="!currentSectionScope">Section</TH>
          <TH>Actions</TH>
        </TRHead>
      </THead>
      <TBody>
        <TRBody v-for="(result, index) in resultsList" :key="index">
          <TD v-show="showColumnInDataTable(filtersData, 'Title', ['Title'])">
            <span
              class="text-primary-purple-600 cursor-pointer"
              @click="redirectToDetailsPage(result.id)"
            >
              {{ result.title || GENERAL_CONSTANT.NOT_APPLICABLE }}
            </span>
          </TD>
          <TD v-show="showColumnInDataTable(filtersData, 'Description')">
            {{ result.description || GENERAL_CONSTANT.NOT_APPLICABLE }}
          </TD>
          <TD
            v-if="!currentStudent"
            v-show="showColumnInDataTable(filtersData, 'Result Generated', ['Result Generated'])"
            v-permission="tableActionsPermissions"
          >
            {{ result.generated_at ? GENERAL_CONSTANT.GENERATED : GENERAL_CONSTANT.NOT_GENERATED }}
          </TD>
          <TD
            v-if="!currentStudent"
            v-show="showColumnInDataTable(filtersData, 'Published')"
            v-permission="tableActionsPermissions"
          >
            {{ result.published_at ? GENERAL_CONSTANT.PUBLISHED : GENERAL_CONSTANT.NOT_PUBLISHED }}
          </TD>
          <TD v-if="!currentSectionScope">
            {{ result.section.title }}
          </TD>
          <TD>
            <span
              v-if="isStudentOrGuardian"
              class="text-primary-purple-600 cursor-pointer"
              @click="goToStudentSectionViewResult(result)"
            >
              View Result
            </span>
            <TableAction
              v-if="!isStudentOrGuardian"
              :action-id="`SectionResultAction${result.title.replace(/\s+/g, '')}`"
              :idx="index"
              :current-user="result"
              :action-list="result.actionList"
              @action="typeAction"
            />
          </TD>
        </TRBody>
      </TBody>
    </TableWrapper>
    <Pagination
      v-if="resultsCounts > GENERAL_CONSTANT.RECORD_LIMIT"
      v-show="!isLoading"
      :record-limit="GENERAL_CONSTANT.RECORD_LIMIT"
      :max-range="paginationCounts(resultsCounts, GENERAL_CONSTANT.RECORD_LIMIT)"
      @filterRecord="filterRecords"
    />
    <SectionResultModal
      v-if="isModalShow"
      :modal="isModalShow"
      :edit="currentSelectedResult"
      @toggle="toggleSubjectExamModal"
    />
    <UIConfirmationModal
      v-if="deleteModelShow"
      :modal="deleteModelShow"
      heading="DELETE_SEC_RESULT"
      message="Are you sure you want to delete "
      button-text="Delete"
      :name="currentSelectedResult.title"
      remaining-message="Result ?"
      :is-loading="isDeleteInProgress"
      @cancel="toogleDeleteModel"
      @confirm="deleteResultById"
    />
    <UIConfirmationModal
      v-if="generteResultModal"
      :modal="generteResultModal"
      heading="GENERATE_RESULT"
      message="Are you sure you want to generate result for "
      button-text="Confirm"
      :name="currentSelectedResult.title"
      @cancel="toggleGenerateResultModal"
      @confirm="generateResultForSubject"
    />
    <UIConfirmationModal
      v-if="reGenerteResultModal"
      :modal="reGenerteResultModal"
      heading="REGENERATE_RESULT"
      message="Are you sure you want to re generate result for "
      button-text="Confirm"
      :name="currentSelectedResult.title"
      @cancel="toggleReGenerateResultModal"
      @confirm="reGenerateResultForSection"
    />
  </div>
</template>

<script>
import SectionResultFilter from '@/src/router/views/exam-planner/grades-manager/SectionResultFilter.vue'
import { mapActions, mapState } from 'vuex'
import { paginationCounts } from '@src/components/BaseComponent/pagination.util.js'
import Pagination from '@components/BaseComponent/Pagination.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import exams from '@/src/state/modules/exams/exams'
import scrollMixin from '@src/mixins/scroll-mixin'
import NoRecordFound from '@/src/components/BaseComponent/NoRecordFound.vue'
import { objectDeepCopy, showColumnInDataTable } from '@utils/generalUtil'
import isEmpty from 'lodash/isEmpty'
import { paginationRangeHandler } from '@src/components/BaseComponent/pagination.util.js'
import GENERAL_CONSTANT from '@src/constants/general-constants.js'
import fileMixin from '@src/mixins/file-mixins'
import TableAction from '@components/TableAction.vue'
import SectionResultModal from '@/src/router/views/exam-planner/grades-manager/AddAndEditSectionResultModal.vue'
import UIConfirmationModal from '@src/components/UiElements/UIConfirmationModal.vue'
import GENERAL_CONSTANTS, { SCOPE_LEVELS } from '@src/constants/general-constants.js'
import sectionResultData from '@src/router/views/exam-planner/grades-manager/sectionResultData.json'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { buildWhereQuery } from '@src/utils/filters/index.js'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'
export default {
  components: {
    SectionResultFilter,
    Pagination,
    Loader,
    NoRecordFound,
    TableAction,
    SectionResultModal,
    UIConfirmationModal,
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
  },
  mixins: [fileMixin, scrollMixin],
  data() {
    return {
      tableActionsPermissions: {
        roles: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
      },
      defaultSelectedColumns: sectionResultData.defaultSelectedColumns,
      tableHeaders: sectionResultData.tableHeaders,
      skipForFilterColumns: sectionResultData.skipForFilterColumns,
      filtersData: {},
      GENERAL_CONSTANT,
      isEmpty,
      isLoading: false,
      currentSelectedResult: null,
      resultsList: [],
      resultsCounts: 0,
      isModalShow: false,
      deleteModelShow: false,
      generteResultModal: false,
      reGenerteResultModal: false,
      isDeleteInProgress: false,
      GENERAL_CONSTANTS,
      get currentStudent() {
        return JSON.parse(localStorage.getItem('currentActiveStudent')) || null
      },
    }
  },
  computed: {
    ...mapState('layout', ['currentSectionScope', 'currentClassScope', 'activeRole']),
    ...mapState('auth', ['currentUser']),
    isSelectedRoleExist() {
      return this.tableActionsPermissions.roles.includes(this.activeRole)
    },
    isStudentOrGuardian() {
      return (
        this.activeRole === TENANT_ROLES.SECTION_STUDENT ||
        this.activeRole === TENANT_ROLES.GUARDIAN
      )
    },
  },
  watch: {
    currentSectionScope: {
      handler(val) {
        this.filterRecords()
      },
    },
    currentClassScope: {
      handler(val) {
        if (val) this.filterRecords()
      },
    },
  },
  created() {
    this.setRightbarData()
    this.filterRecords()
    this.updateTableHeaders()
  },
  methods: {
    showColumnInDataTable,
    paginationCounts,

    goToStudentSectionViewResult(result) {
      this.currentSelectedResult = result
      this.$router?.push({
        name: 'final-result-detail-view',
        params: { id: result.id, resultId: this.currentUser.id },
      })
    },

    updateTableHeaders() {
      this.tableHeaders.forEach((header) => {
        if (header.dataTableName === 'Published' || header.dataTableName === 'Result Generated') {
          header.skipForDataTableHead =
            !this.isSelectedRoleExist || (this.isSelectedRoleExist && this.currentStudent)
        }
      })
    },
    applyFilters(filtersPayload) {
      this.filtersData = objectDeepCopy(filtersPayload)
      this.filterRecords()
    },
    deleteResultById() {
      this.deleteType(this.currentSelectedResult.id)
    },
    async filterRecords(range) {
      if (!this.currentClassScope) return

      this.isLoading = true
      const paginationLimit = paginationRangeHandler(range)
      let payload = {
        ...paginationLimit,
      }
      payload = this.filtersData ? { ...payload, ...{ $where: this.filtersData?.$where } } : payload
      const [response, err] = this.isStudentOrGuardian
        ? await this.getStudentSectionResultList(payload)
        : await this.getSectionResultList(payload)
      this.isLoading = false
      if (!err) {
        this.resultsList = response?.data?.records
        this.resultsList.forEach(
          (result) =>
            (result['actionList'] = this.checkActionsBasedOnPermissions(
              this.getActionsList(result.generated_at),
            )),
        )
        this.resultsCounts = response?.data?.meta?.total_records
        this.setRightbarData(this.resultsCounts)
      }
    },
    getActionsList(generatedAt) {
      let actions = [{ name: 'Edit' }, { name: 'Delete' }]
      generatedAt
        ? actions.unshift({ name: 'VIEW_RESULT' }, { name: 'REGENERATE_RESULT' })
        : actions.unshift({ name: 'GENERATE_RESULT' })
      return actions
    },

    checkActionsBasedOnPermissions(actions) {
      if (!this.isSelectedRoleExist || (this.isSelectedRoleExist && this.currentStudent)) {
        return actions.filter((action) => action.name === 'VIEW_RESULT')
      }
      return actions
    },
    toggleSubjectExamModal(payload) {
      this.isModalShow = !this.isModalShow
      if (!this.isModalShow) this.currentSelectedResult = null
      if (payload) this.filterRecords()
    },
    typeAction(action, currentType, idx) {
      this.currentSelectedResult = currentType
      switch (action) {
        case 'Edit':
          this.toggleSubjectExamModal()
          break
        case 'Delete':
          this.toogleDeleteModel()
          break
        case 'GENERATE_RESULT':
          this.toggleGenerateResultModal()
          break
        case 'VIEW_RESULT':
          let navigationRoute
          if (this.currentStudent?.id) {
            navigationRoute = { name: 'student-final-result-view', params: { id: currentType.id } }
          } else if (
            this.activeRole !== TENANT_ROLES.SECTION_STUDENT &&
            this.activeRole !== TENANT_ROLES.GUARDIAN
          ) {
            navigationRoute = { name: 'section-result-view', params: { id: currentType.id } }
          } else {
            navigationRoute = {
              name: 'final-result-detail-view',
              params: { id: currentType.id, resultId: this.currentUser.id },
            }
          }
          this.$router?.push(navigationRoute)
          break
        case 'REGENERATE_RESULT':
          this.toggleReGenerateResultModal()
          break
      }
    },
    async generateResultForSubject() {
      let id = this.currentSelectedResult?.id
      let [response, error] = await this.generateSectionResult(id)
      if (response) {
        this.toggleGenerateResultModal()
        this.currentSelectedResult = null
        this.filterRecords()
        this.$store.commit(
          'toast/NEW',
          { message: response.data.message, type: 'success' },
          { root: true },
        )
      }
    },
    async reGenerateResultForSection() {
      let id = this.currentSelectedResult?.id
      let [response, error] = await this.reGenerateSectionResult(id)
      if (response) {
        this.toggleReGenerateResultModal()
        this.filterRecords()
        this.$store.commit(
          'toast/NEW',
          { message: response.data.message, type: 'success' },
          { root: true },
        )
      }
    },
    async deleteType(id) {
      this.isDeleteInProgress = true
      let [response, error] = await this.deleteSectionExamResult(id)
      this.isDeleteInProgress = false
      if (response) {
        this.toogleDeleteModel()
        this.filterRecords()
      }
    },
    toogleDeleteModel() {
      this.deleteModelShow = !this.deleteModelShow
      if (!this.deleteModelShow) this.currentSelectedResult = null
    },
    toggleGenerateResultModal() {
      this.generteResultModal = !this.generteResultModal
      if (!this.generteResultModal) this.currentSelectedResult = null
    },
    toggleReGenerateResultModal() {
      this.reGenerteResultModal = !this.reGenerteResultModal
      if (!this.reGenerteResultModal) this.currentSelectedResult = null
    },
    redirectToDetailsPage(id) {
      this.$router?.push({
        name: this.currentStudent?.id ? 'student-final-result-detail' : 'final-result-detail',
        params: { id },
      })
    },
    setRightbarData(count = 0) {
      const rightBarContent = {
        header: {
          title: 'SECT_EXAM_RES',
          buttons: this.currentStudent
            ? []
            : [
                {
                  title: 'ADD_SECT_EXAM_RESULT',
                  classes: ['primary-button-right'],
                  action: {
                    func: () => {
                      this.toggleSubjectExamModal()
                    },
                  },
                  permissions: {
                    roles: [
                      TENANT_ROLES.SUPER_ADMIN,
                      TENANT_ROLES.CAMPUS_ADMIN,
                      TENANT_ROLES.SECTION_TEACHER,
                    ],
                  },
                },
              ],
        },
        stats: [
          {
            title: GENERAL_CONSTANTS.STATS_AND_SUMMARY,
            categories: [{ text: 'TOTAL_SECTION_RESULT', value: count }],
          },
        ],
      }
      this.setRightbarContent(rightBarContent)
    },
    ...mapActions('layout', ['setRightbarContent']),
    ...mapActions('exams', [
      'getSectionResultList',
      'getStudentSectionResultList',
      'deleteSectionExamResult',
      'generateSectionResult',
      'reGenerateSectionResult',
    ]),
  },
}
</script>
